export default __webpack_public_path__ + "static/media/V280_RoHS.670b9b6f.pdf";